import { render, staticRenderFns } from "./ClassifiedSingleViewComp.vue?vue&type=template&id=3cd128f5&"
import script from "./ClassifiedSingleViewComp.vue?vue&type=script&lang=js&"
export * from "./ClassifiedSingleViewComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports